import { I18n } from 'react-redux-i18n';

export function validator({
  contactId, userId, firstName, email, isEmailSelected,
}) {
  if (!isEmailSelected) {
    return { message: I18n.t('selectEmail'), success: '' };
  }
  if (!contactId) {
    return { message: I18n.t('selectContact'), success: '' };
  }
  if (!contactId && email) {
    return { message: I18n.t('emailNotRegistered'), success: '' };
  }
  if (!userId) {
    if (!firstName) {
      return { message: I18n.t('insertFirstName'), success: '' };
    }
  }
  return { success: 'valid' };
}

export function validatorExtra({
  locationId, bu, deposit
}) {
  if (!locationId) return { message: I18n.t('placeNotSelected') };
  if (!bu && bu !== 0) return { message: I18n.t('buNotSelected') };
  if (!deposit || deposit == '') return { message: I18n.t('depositNotSelected') };
  return { success: 'valid' };
}

export default {
  validator,
  validatorExtra,
};
